module.exports = __webpack_public_path__ + "media/images/athletes/3390-0f10183087a86f4abe5b59e0fcefc1e8.png";